<template>
	<div class="manage">
		<div class="information-hr"></div><div class="information-hr2"></div>
        <div class="role-tips">
			    <p class="roles">操作注意事项： </p>
				<span>在“初稿已提交”状态时可以对提交的稿件任意进行修改和撤回。 </span><br />
				<span class="color">进入“初审中”状态则无法撤回，且最多只有3次修改机会。</span><br />
				<span class="last">初审通过后无法修改投稿内容，但仍然可以进行留言操作。</span>
	    	</div>
		<p class="top">
			<span class="big">投稿记录</span>  共有<span class="numb">{{totalNum}} </span>份投稿待审核 
			<el-select v-model="status" placeholder="审核状态" class="search">
		      <el-option label="全部" value="0"></el-option>
		      <el-option label="初审已提交" value="1"></el-option>
		      <el-option label="初审中" value="2"></el-option>
		      <el-option label="初审已通过" value="3"></el-option>
		      <el-option label="复审已受理" value="4"></el-option>
		      <el-option label="复审中" value="5"></el-option>
		      <el-option label="复审已通过" value="6"></el-option>
		      <el-option label="未通过" value="7"></el-option>
		      <el-option label="已撤回" value="8"></el-option>
		    </el-select>
		    <el-select v-model="sort" placeholder="排序" class="search search2">
		      <el-option label="按创建时间降序" value="1"></el-option>
		      <el-option label="按创建时间升序" value="2"></el-option>
		    </el-select>
		    <el-button type="primary" icon="el-icon-search" class="search search3" @click='search'>搜索</el-button>
        </p>
		 <el-table align='center'  :data="tableData"
		    style="width: 100%;margin: 0 auto;width: 860px;border-radius: 15px;margin-bottom: 20px;">
		    <el-table-column align='center'  label="投稿 编号"  width="170">
		      <template slot-scope="scope">
		        <span>{{ scope.row.num_order }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column  label="作品名称"  width="160" align='center'>
		      <template slot-scope="scope">
		      	{{ scope.row.title }}
		      </template>
		    </el-table-column>
		    <el-table-column  label="投稿 /修改时间"  width="160" align='center'>
		      <template slot-scope="scope">
		        <span>{{ scope.row.created_at }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column  label="审核状态"  width="150" align='center'  >
		      <template slot-scope="scope">
		        <span :style="{color:scope.row.color}" >{{ scope.row.statusNum }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column label="操作" width="190" align='center'>
		      <template slot-scope="scope">
		        <el-button size="mini"  @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.statusNum !== '已撤回'">修改/留言</el-button>
		        <el-button  size="mini" type="danger"  @click="handleDelete(scope.$index, scope.row)" v-if="scope.row.statusNum !== '已撤回'" :disabled="scope.row.statusNum !== '初审已提交'">撤回</el-button>
		        <!-- <el-button  size="mini"    @click="handle(scope.$index, scope.row)" v-if="scope.row.statusNum !== '已撤回'">留言</el-button> -->
		        <el-button  size="mini" @click="handleEdit(scope.$index, scope.row)" v-if="scope.row.statusNum === '已撤回'">查看</el-button>
		        <el-button  size="mini" @click="deleteItem(scope.$index, scope.row)" v-if="scope.row.statusNum === '已撤回'">删除</el-button>
		      </template>
		    </el-table-column>
		  </el-table>
		   <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange"  :page-size="pageSize"  layout="prev, pager, next, jumper"  :total="total" style="text-align: center;"></el-pagination>
	    	<div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	      <div class="back-url">
	      	<el-button type="primary" @click='contribute'>投稿记录查询</el-button>
	      	<span>点击此按钮可跳转至审核进度查询页面对投稿记录进行详细查询</span>
	      </div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				tableData: [],
		        total:0,
		        status:'',
		        sort:'',
		        page:1,
		        pageSize:10,
		        totalNum:0,
			}
		},
		methods:{
			createTable(status,sort,page){
				var form = new FormData
				form.append('status',status)
				form.append('sort',sort)
				form.append('page',page)
				form.append('pageSize',this.pageSize)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/apply/lists',
					data:form,
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.total = res.data.data.total
						this.tableData = res.data.data.rows
						var data = res.data.data.rows

						for (var i = 0; i < data.length; i++) {
								data[i]['title'] = unescape(data[i]['title']) 					
							if(data[i].status == '1'){
								data[i].statusNum = '初审已提交'
								data[i].color = 'black'
								this.activeColor = data[i].color
							}
							if(data[i].status == '2'){
								data[i].statusNum = '初审中'
								data[i].color = '#D4AD25'
								this.activeColor = data[i].color
							}
							if(data[i].status == '3'){
								data[i].statusNum = '初审已通过'
								data[i].color = '#4DC55E'
								this.activeColor = data[i].color
							}
							if(data[i].status == '4'){
								data[i].statusNum = '复审已受理'
								data[i].color = '#A84FF4'
								this.activeColor = data[i].color
							}
							if(data[i].status == '5'){
								data[i].statusNum = '复审中'
								data[i].color = '#D4AD25'
								this.activeColor = data[i].color
							}
							if(data[i].status == '6'){
								data[i].statusNum = '复审已通过'
								data[i].color = '#4DC55E'
								this.activeColor = data[i].color
							}
							if(data[i].status == '7'){
								data[i].statusNum = '未通过'
								data[i].color = '#E13333'
								this.activeColor = data[i].color
							}
							if(data[i].status == '8'){
								data[i].statusNum = '已撤回'
								data[i].color = 'black'
								this.activeColor = data[i].color
							}
						}
					} else{
						this.$message({
				          message: res.data.message,
				          type: 'warning'
				        });
					}
				}),
				axios({
					method:'get',
					url:process.env.BASE_URL+'/apply/countNum?status=1',
					withCredentials:true
				}).then(res =>{
					this.totalNum = res.data.data.total
				})
			},
			
			handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		       this.createTable(0,1,val)
		       this.page = val
		    },
			handleEdit(index,row){
				//修改
				 this.$router.push({ path: 'edit', query: { id: row.id }})
			},
			lookOver(index,row){
				//撤回查看
				 this.$router.push({ path: 'lookOver', query: { id: row.id }})
			},
			deleteItem(index,row){
				//撤回删除
				axios({
					method:'post',
					url:process.env.BASE_URL+'/apply/delApply?id='+row.id,
					withCredentials:true
				}).then(res =>{
					if (res.data.code == 10000) {
                        this.$confirm('删除成功', '提示', {
				          confirmButtonText: '确定',
				          showCancelButton:false,
				          type: 'success'
				        }).then(() => {
				           this.createTable(0,1,1)
				        }).catch(() => {     
				        });
					}
					else{
                        this.$message.error(res.data.message)
					}
				})
			},
			handleDelete(index,row){
				//撤回
                this.$confirm('此操作将撤回该投稿, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		            var form1 = new FormData
					form1.append('id',row.id)
					axios({
						method:'post',
						url:process.env.BASE_URL+'/apply/recall',
						data:form1,
						withCredentials:true
					})
					.then(res =>{
						if (res.data.code == 10000) {
							this.$message({
					          message: res.data.message,
					          type: 'success'
					       });
					       if(this.status =='' && this.sort == ''){this.createTable(0,1,this.page)}
					       if (this.status != '' && this.sort == '') {this.createTable(this.status,1,this.page)}
					       if (this.status == '' && this.sort != '') {this.createTable(0,this.sort,this.page)}
					       if (this.status != '' && this.sort != '') {
					       	this.createTable(this.status,this.sort,this.page)
					       }
						} else{
							this.$message({
					          message: res.data.message,
					          type: 'warning'
					        });
						}
					})
		        }).catch(() => {
		          this.$message({
		            type: 'info',
		            message: '已取消撤回'
		          });          
		        });
				
			},
			handle(index,row){
				//留言
				var rows = JSON.stringify(row)
				 this.$router.push({ path: 'leaveMessage', query: { id: row.id }})
			},
			contribute(){
			  this.$store.commit('SET_ISPERSON', true)
			  this.$store.commit('SET_ISLOGIN', false)
			  this.$store.commit('SET_ISCENTER', true)
			  this.$store.commit('SET_ISFIRST', false)
              this.$router.push({ path: '/progress'})
			},
			search(){				
			   if(this.status =='' && this.sort == ''){this.createTable(0,1,this.page)}
		       if (this.status != '' && this.sort == '') {this.createTable(this.status,1,this.page)}
		       if (this.status == '' && this.sort != '') {this.createTable(0,this.sort,this.page)}
		       if (this.status != '' && this.sort != '') {
		       	this.createTable(this.status,this.sort,this.page)
		       }
			}
		},
		created(){
			this.createTable(0,1,1)
		},
	}
</script>

<style scoped>
	.manage{
		 position: relative; padding:0 10px;
	}
	.roles{
		padding-top: 30px;
		font-size: 20px;
	}
	.color{
		color: #F6A68B;
	}
	.last{
		display: inline-block;
	}
	.top{
		padding: 20px;
		padding-top: 25px; position: relative;
	}
	.big{
		font-size: 22px;
	}
	.numb{
		color: red;
	}
	.search{
		position: absolute;
		top: 25px;
		right: 110px;
		width: 160px;
	}
	.search2{
		right: 280px;
	}
	.search3{
		right: 10px;
		width: 90px;
	}
	.information-hr, .information-hr2{
	margin-left: -10px;
}
.information-hr2{
	top: -7px;
}
.information-hr-bottom, .information-hr2-bottom{
	margin-left: -10px;
}
.role-tips{ padding-left: 20px; line-height: 26px;}
.back-url{ overflow: hidden; padding:50px 0 80px 30px;}
.back-url span{ color: #ff6a30; font-size: 14px; padding-left: 10px; }
</style>


// WEBPACK FOOTER //
// src/views/manage.vue